import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shownegative',
})
export class ShownegativePipe extends DecimalPipe {
  transform(value: number): any {
    if (isNaN(value) === false && value !== 0) {
      return `-${super.transform(value)}`;
    }
    return '-';
  }
}



// WEBPACK FOOTER //
// ./src/app/shownegative.pipe.ts